<template>

   <!-- <div class="modal-dialog">
      <div class="modal-content">

         <div class="modal-header justify-content-end" style="background-color: #00A0C1; height:50px;">
            <div>
               <button ref="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetForm()"></button>
            </div>
         </div>
         
         <div class="modal-body"> -->

            <div class="row text-center justify-content-center">
               <h1 class="modal-title"><strong> Category </strong></h1>
            </div>

            <hr />

            <form class="row mx-4 g-0" style="gap: 1rem">

               <div class="form-floating">
                  <select class="form-select" id="group" v-model.trim="category.group" @blur="v$.category.group.$touch"
                     @change="v$.category.group.$touch" disabled>
                     <option selected disabled value>Please choose...</option>
                     <option v-for="group in groups" :value="group.id" :key="group.id">{{group.display_name}}</option>
                  </select>
                  <label for="group" class="text-muted">Group</label>
                  <span class="form-text text-danger" v-if="v$.category.group.$dirty && category.group==''">
                     Group is required.
                  </span>
               </div>

               <div class="form-floating">
                  <input type="text" id="categoryName" v-model.trim="category.name" @blur="v$.category.name.$touch"
                     class="form-control" placeholder="Category Name" :disabled="isEditing" @input="isUnique.name=true"/>
                  <label for="categoryName" class="text-muted">Category Name</label>
                  <div class="pt-1">
                     <span class="form-text" :class="{'text-danger' : v$.category.name.alphaNumericUnderscore.$invalid, 
                        'text-muted' : !v$.category.name.alphaNumericUnderscore.$invalid}">
                        Minimum of 3 characters long. Must contain letters, numbers and underscores only.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="v$.category.name.required.$invalid && v$.category.name.$dirty">
                        Category Name is required.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="!isUnique.name">
                        Category Name already exists.
                     </span>
                  </div>
                  
               </div>
               
               <div class="form-floating">
                  <input type="text" id="displayName" v-model.trim="category.displayName" @blur="v$.category.displayName.$touch"
                     class="form-control" placeholder="Display Name" @input="isUnique.displayName=true"/>
                  <label for="displayName" class="text-muted">Display Name</label>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="v$.category.displayName.required.$invalid && v$.category.displayName.$dirty">
                        Display Name is required.
                     </span>
                  </div>
                  
                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="!isUnique.displayName">
                        Display Name already exists.
                     </span>
                  </div>
               </div>
               
               <div class="pt-2 pb-2 justify-content-center d-flex" style="gap:0.5rem">
                  <button v-if="!isEditing" type="button" class="btn btn-outline-warning" @click="resetForm()">Clear fields</button>
                  <button v-if="!isEditing" type="button" class="btn btn-info text-light"
                     @click="createCategory()" :disabled="disableFormButton()"> Create </button>
                  <button v-if="isEditing" type="button" class="btn btn-info text-light"
                     @click="updateCategory(category.id)" :disabled="disableFormButton()"> Update </button>
               </div>
            </form>

         <!-- </div>
      </div>
   </div> -->

   <ConfirmModal
      v-model="showConfirmModal"
      :title="confirmModalTitle"
      :message="confirmModalMessage"
      @confirm="onConfirmAction"
   />

</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

const alphaNumericUnderscore = helpers.regex(/^[a-zA-Z0-9][\w]+[a-zA-Z0-9]$/) //matches alphaNumeric and underscores

export default ({
   setup () {
      return { v$: useVuelidate() }
   },

   data(){
      return{
         groups: [],
         categories: [],
         category: {
            id: '',
            name: '',
            displayName: '',
            group: '',
         },
        isEditing: false,
        isUnique: {
            name: true,
            displayName: true,
        },
         showConfirmModal: false,
         confirmModalTitle: '',
         confirmModalMessage: '',
         pendingDeleteId: null,
      }
   },

   validations() {
      return {
         category: {
            name: { required, alphaNumericUnderscore },
            displayName: { required },
            group: { required },
         },
        
      }
   },

   methods: {

      isCreate(groupId){
         this.isEditing = false
         this.getGroupsList()
         this.addCategory(groupId)
      },

      isEdit(id){
         this.isEditing = true
         this.getGroupsList()
         this.getCategory(id)
      },

      isDelete(id){
         this.deleteCategory(id)
      },

      async getGroupsList() {
         await this.$axios.get("/groups")
         .then((response) => {
            this.groups = response.data.groups
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      async getCategory(id) {

         await this.$axios.get("/categories/"+id)
         .then((response) => {
            this.category.id = response.data.category.id
            this.category.name = response.data.category.name
            this.category.displayName = response.data.category.display_name
            this.category.group = response.data.category.group_id
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })

      },

      resetForm() {
         this.v$.$reset()
         this.category.id = ""
         this.category.name = ""
         this.category.displayName = ""
         this.isEditing = false
         this.isUnique.name = true
         this.isUnique.displayName = true
      },

      disableFormButton() {
         if (this.v$.$error || this.v$.$invalid){
            return true
         }

         return false
      },

      async addCategory(id){

         await this.$axios.get("/groups/"+id)
         .then((response) => {
           this.category.group  = response.data.group.id
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      async createCategory() {

         let category = {
            name : this.category.name,
            display_name : this.category.displayName,
            group_id : this.category.group,
         }
        
         await this.$axios.post("/categories",category)
         .then((response) => {

            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$refs.closeModal.click();
               this.resetForm();

               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.checkError(error)
         })

      },

      async updateCategory(id) {

         let category = {
            // name : this.category.name,
            display_name : this.category.displayName,
            group_id : this.category.group,
         }

         await this.$axios.put("/categories/"+id, category)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$refs.closeModal.click();
               this.resetForm();

               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.checkError(error)
         })
         
      },

      async deleteCategory(id) {
         this.pendingDeleteId = id;
         this.confirmModalTitle = 'Delete Category';
         this.confirmModalMessage = 'Do you want to delete this category?\n\nAll subcategories under this category will also be deleted.';
         this.showConfirmModal = true;
      },

      async onConfirmAction() {
         const id = this.pendingDeleteId;
         this.pendingDeleteId = null;
         if (!id) return;
         await this.$axios.delete("/categories/"+id)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      checkError(error) {
         if(error.response.data.message == "Category Name already exists."){
            this.isUnique.name = false
         } else if(error.response.data.message == "Display Name already exists."){
            this.isUnique.displayName = false
         } else {
            this.$toast.error(error.response.data.message)
         }
      },
   },
 
})
</script>

<style scoped>

.btn {
   width: 7rem;
}

</style>